import { format } from "date-fns";
import { StructuredTextDocument } from "datocms-structured-text-to-html-string";
import React from "react";
import { removeTimeZone } from "../../helpers/dateTimeDatoString";
import { EventPageUiLabels } from "../../templates/event";
import Divider from "../Divider";
import ResponsiveContentWidthWrapper from "../ResponsiveContentWidthWrapper";
import SectionWrapper from "../SectionWrapper";
import StructuredTextGeneric from "../StructuredTextGeneric";

interface Props {
  sectionAgenda: Queries.EventPageQuery["datoCmsEvent"]["sectionAgenda"];
  uiLabels: EventPageUiLabels;
}

const EventPageSectionAgenda = ({
  sectionAgenda: [{ agenda }],
  uiLabels,
}: Props) => {
  const label = uiLabels.agenda;
  const formatter = "hh:mm aaa";

  return (
    <SectionWrapper noBorder>
      <ResponsiveContentWidthWrapper>
        <>
          <Divider additionalClassName="mb-16" />
          <div>
            <h2 className="text-xl md:text-2xl">{label}</h2>
            <table className="w-full">
              <tbody className="mt-6 flex flex-col gap-6">
                {agenda.map((item) => {
                  const { from, description } = item;
                  const fromWithoutTimeZone = removeTimeZone(from);
                  const fromDateTime = new Date(fromWithoutTimeZone);
                  const agendaTime = format(fromDateTime, formatter);
                  const data = description as unknown as StructuredTextDocument;

                  return (
                    <tr
                      key={from}
                      className="grid grid-cols-1 gap-2 sm:grid-cols-12 sm:gap-0"
                    >
                      <td className="sm:col-span-2">{agendaTime}</td>
                      <td className="sm:col-span-10">
                        <StructuredTextGeneric data={data} isAgendaItem />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      </ResponsiveContentWidthWrapper>
    </SectionWrapper>
  );
};

export default EventPageSectionAgenda;
